import { useMutation } from 'react-query';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig, queryClient } from 'src/lib/react-query';

interface IloginFormData {
  username: string;
  password: string
}

interface IUserLoginPostApi {
    userName: string;
    password: string;
    loginTypeID: number;
    sysApplicationsID: number;
}

interface IUserLoginPostResponse {
    applicationUser: {
        applicationUsersCorrelations: any[];
        resource: string;
        id: number;
        username: string;
        lastName: string;
        firstName: string;
        email: string;
        languageId: number;
        userType: number;
        loginType: number;
        appID: number;
        active: boolean;
        visible: boolean;
        deleted: boolean;
        resourceName: string;
    },
    token: string;
}

const login = ( {data} : {data: IloginFormData | {}}): Promise<IUserLoginPostResponse> => {
  const applcationID = process.env.REACT_APP_ID ? +process.env.REACT_APP_ID : -1;
  let prepareData: IUserLoginPostApi = {userName: 'emptyUsername', password: 'emptyPassword', loginTypeID: 1, sysApplicationsID: applcationID }
  if ('username' in data && 'password' in data) {
    prepareData = {userName: data.username, password: data.password, loginTypeID: 1, sysApplicationsID: applcationID }
  }
  return axiosDefaultApi.post(`api/Authentication/Authenticate`, prepareData);
};

type QueryFnType = typeof login;

type UseLoginOptions = {
  data: IloginFormData | {};
  config?: MutationConfig<QueryFnType>;
};

export const useLogin = ({ data, config }: UseLoginOptions) => {
    return useMutation({
        onError: (error: any) => {
            if(error.code && error.code === "ERR_NETWORK"){
              error.response = {data: "Network Error, please contact with your administrator"}
              return error;
            }
            if(!error.response?.data){
              error.response = {data: "Please contact with your administrator"}
              return error;
            }

            return error;
          },
          onSuccess: (data: IUserLoginPostResponse) => {
            console.log('Success login.');
            localStorage.setItem(`${process.env.REACT_APP_BASENAME}_authUser`, JSON.stringify(data));
          },
        ...config,
        mutationFn: login
    })
}